<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftReasonBase from '../../../../../shift_reasons/components/ShiftReasonBase.vue'

definePage({
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

// The settings layout hands every tab the site; this one reads it from the site context instead
defineOptions({ inheritAttrs: false })
</script>

<template>
  <ShiftReasonBase />
</template>
